import React, { FC, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts'
import { SOCIAL_LOGIN } from 'graphql/service'
import { AuthCallbackGoogleContainer } from './styles'
import { useAuth } from 'customHooks/useAuth'

const debug = false

const AuthCallbackGoogle: FC = () => {
  

  const { loginWithToken } = useAuth()

  useHistory()
  const location = useLocation()
  const { showGlobalError, showGlobalMessage } = useGlobalAlerts()

  const [socialLogin] = useMutation(SOCIAL_LOGIN)

  

  useEffect(() => {
    const params = new URLSearchParams(location.search)

    const code = params.get('code')
    const returnedState = params.get('state')
    const oauthError = params.get('error')

    if (debug) {
        console.log ('code:', code);
        console.log ('returnedState:', returnedState);
        console.log ('oauthError:', oauthError);
    }


    if (oauthError) {
      showGlobalError(oauthError)
      return
    }

    if (!code) {
      showGlobalError('Missing authorization code.')
      return
    }

    const savedState = sessionStorage.getItem('oauth_state')
    if (!returnedState || !savedState || returnedState !== savedState) {
      showGlobalError('Invalid OAuth state. Please try again.')
      return
    }

    const codeVerifier = sessionStorage.getItem('pkce_verifier_GOOGLE')
    if (!codeVerifier) {
      showGlobalError('Missing PKCE code verifier. Please try again.')
      return
    }

    if (debug) {
        console.log ('codeVerifier:', codeVerifier);
    }

    const redirectUri = `${window.location.origin}/auth/callback/google`

    if (debug) {
        console.log ('redirectUri:', redirectUri);
    }


    socialLogin({
      variables: {
        input: {
          provider: 'GOOGLE',
          authorizationCode: code,
          codeVerifier: codeVerifier,
          redirectUri: redirectUri
        },
      },
    })
      .then((res) => {
        const token = res?.data?.socialLogin?.accessToken

        if (!token) {
          showGlobalError('Social login failed: no access token returned.')
          return
        }

        loginWithToken(token, '/account/dashboard')

        showGlobalMessage('Signed in successfully.')
        
      })
      .catch((e) => {
        showGlobalError(e?.message || 'Social login failed.')
      })
  }, [location.search, loginWithToken, showGlobalError, showGlobalMessage, socialLogin])

  return (
    <AuthCallbackGoogleContainer>
        <div style={{ padding: 100 }}>Completing Google sign-in...</div>
    </AuthCallbackGoogleContainer>

  )
}

export default AuthCallbackGoogle